import Backdraft from "backdraft-app/src/backdraft";
import _ from "underscore";

Backdraft.app("Shared/SignalExpression", function(app) {
  app.model("NotTerminal", "ExpressionTerminal", {
    beforeSet: function(attributes) {
      return _.extend({}, attributes, { terminal: 'not' });
    },

    isNotTerminal: function() {
      return true;
    }
  });
});
